module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms8-65f25ad726690e90a866884f05089a99.jpg";